module.exports = __webpack_public_path__ + "officialStatic/img/solution-wifi.8d21370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/solution-wifi.png
// module id = J7hS
// module chunks = 0